import { jsx as _jsx } from "react/jsx-runtime";
import { Apps } from '@web/components/Apps';
import { Page } from '@web/pages/layout/Page';
export var AppsView = function () {
    return (_jsx(Page, { children: _jsx(Apps, {}) }));
};
